import React, { useContext } from "react";
import {
  Container,
  Grid,
  Typography,
  Button,
  Avatar,
  Stack,
  Box,
  Paper,
  Link,
} from "@mui/material";
import {
  CalendarToday,
  People,
  Settings,
  Notifications,
  ArrowForward,
  Phone,
  DirectionsRun,
  Call,
  LocationSearching,
} from "@mui/icons-material";
import { BaseAppContext } from "../../utils/context";
import { getGreeting } from "../../utils/GreetingUtils";
import { useNavigate } from "react-router-dom";

const PatientDashboard: React.FC = () => {
  const { loggedUserName } = useContext(BaseAppContext);

  return (
    <>
      <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
        {/* Header Section */}
        <Box sx={{ mb: 4 }}>
          <Typography variant="h4" fontWeight="600" gutterBottom>
            {getGreeting()}, {loggedUserName}
          </Typography>
          <Typography variant="subtitle1" color="text.secondary">
            {new Date().toLocaleDateString("en-US", {
              weekday: "long",
              month: "long",
              day: "numeric",
            })}
          </Typography>
        </Box>

        {/* Quick Stats */}
        <Grid container spacing={3} sx={{ mb: 3 }}>
          <Grid item xs={12} sm={6} md={3}>
            <StatCard
              icon={<CalendarToday fontSize="large" color="primary" />}
              title="Book Appointment"
              actionText="Book Now"
              path="/appointment"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <StatCard
              icon={<LocationSearching fontSize="large" color="success" />}
              title="Track Bookings"
              actionText="Track Now"
              path="/track-bookings"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <StatCard
              icon={<Call fontSize="large" color="warning" />}
              title="Emergency Help"
              actionText="Get Help"
              path="/emergency"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <StatCard
              icon={<Settings fontSize="large" color="error" />}
              title="Profile & Settings"
              actionText="Edit Profile"
              path="/profile"
              value={""}
            />
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

const StatCard = ({ icon, title, value, actionText, path }: any) => {
  const navigate = useNavigate();

  return (
    <Paper elevation={2} sx={{ p: 3, height: "100%" }}>
      <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 2 }}>
        <Avatar sx={{ bgcolor: "transparent" }}>{icon}</Avatar>
        <Typography variant="subtitle2" color="text.secondary">
          {title}
        </Typography>
      </Stack>
      <Typography variant="h4" fontWeight="600" minHeight={30} sx={{ mb: 2 }}>
        {value}
      </Typography>
      <Button
        onClick={() => navigate(path)}
        variant="text"
        size="small"
        endIcon={<ArrowForward />}
        sx={{ color: "primary.main", p: 0 }}
      >
        {actionText}
      </Button>
    </Paper>
  );
};

export default PatientDashboard;
